import React from 'react'
import UnderMaintenance from '../components/underMaintenance/UnderMaintenance'

const UnderMaintain = () => {
  return (
    <div>
        <UnderMaintenance />
    </div>
  )
}

export default UnderMaintain